import(/* webpackMode: "eager" */ "/codebuild/output/src2232688212/src/app/home/page.tsx");
